import { RouteConfig } from 'vue-router';
import { tabRoutes } from '@/common/RouteUtils';

export const milkProductRoutes: RouteConfig[] = [
	{
		path: '/account/products/milk/:productId',
		name: 'products.milk.view',
		component: () => import(/* webpackChunkName: "account" */ './view.vue'),
		meta: { auth: true, title: 'Products', showJob: false },
		redirect: { name: 'products.milk.general.information' },
		children: [
			...tabRoutes('products.milk', [
				'general/information',
				'general/change-log',
				'general/billing-change-log',
				'partner-orgs',
				'collections',
				'sms-charges/current',
				'sms-charges/history',
				'alerts/manage',
				'alerts/subscriptions',
				'alerts/deleted-subscriptions',
				'alerts/change-log',
				'alerts/sent',
				'milking-time',
				'map',
				'users/list',
				'users/change-log',
				'transceivers',
				'faults',
				'simpro-jobs',
				'repair-job-texts',
				'accessories',
			]),
			{ path: 'vats/overview', name: 'products.milk.vats.overview', meta: { auth: true } },
			{
				path: 'vats/:vatId',
				name: 'products.milk.vats.detail',
				redirect: { name: 'products.milk.vats.detail.charts' },
				meta: { auth: true },
				children: tabRoutes('products.milk.vats.detail', [
					'charts',
					'general',
					'corrections/settings',
					'corrections/history',
					'collections',
					'change-log',
					'offset-change-log',
					'accessories',
				]),
			},
			{
				path: 'collections/:collectionVatId',
				name: 'products.milk.collections.vat',
				meta: { auth: true },
			},
		],
	},
	{
		path: '/account/products/milk/:productId/vat/:vatId',
		name: 'products.milk.vat',
		redirect: { name: 'products.milk.vats.detail.charts' },
		meta: { auth: true },
	},
];
